import { useEffect, useRef } from 'react'
import { useSession } from './useSession'
import { getProduct } from '../config'
import { EVENTS, identify, initAnalytics, resetIdentity, track } from '../lib/analytics'

/**
 * Renders nothing. Starts analytics once, and keeps PostHog's idea of who is
 * using the app in step with the session: identified (by user id and
 * workspace, never email) when signed in, forgotten on sign-out.
 */
export function AnalyticsBridge() {
  const session = useSession()
  const started = useRef(false)
  const wasSignedIn = useRef(false)

  useEffect(() => {
    if (started.current) return
    started.current = true
    initAnalytics(getProduct().id)
  }, [])

  const userId = session.status === 'authenticated' ? session.user.id : null
  const organizationId = session.status === 'authenticated' ? session.organizationId : null

  useEffect(() => {
    if (userId && organizationId) {
      identify(userId, organizationId, getProduct().id)
      if (!wasSignedIn.current) track(EVENTS.signedIn)
      wasSignedIn.current = true
    } else if (session.status === 'unauthenticated' && wasSignedIn.current) {
      track(EVENTS.signedOut)
      resetIdentity()
      wasSignedIn.current = false
    }
  }, [userId, organizationId, session.status])

  return null
}
